export default __webpack_public_path__ + "static/media/SkModernistBold.109e834c.otf";